<template>
  <div class="table-empty">
    <div class="table-empty__icon">
      <feather-icon
        :icon="icon"
        size="24"
      />
    </div>
    <p class="table-empty__title">
      {{ title }}
    </p>
    <p
      v-if="hint"
      class="table-empty__hint"
    >
      {{ hint }}
    </p>
    <b-button
      v-if="actionText && actionTo"
      size="sm"
      variant="outline-primary"
      :to="actionTo"
      class="mt-1"
    >
      {{ actionText }}
    </b-button>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },

  props: {
    icon: {
      type: String,
      default: 'InboxIcon',
    },
    title: {
      type: String,
      default: 'No hay nada por aquí todavía',
    },
    hint: {
      type: String,
      default: '',
    },
    actionText: {
      type: String,
      default: '',
    },
    actionTo: {
      type: [Object, String],
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.5rem 1rem;
}

.table-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 1rem;
  margin-bottom: 0.85rem;
  background: #f5f3fa;
  color: #340668;
}

.table-empty__title {
  font-size: 1rem;
  font-weight: 600;
  color: #25233a;
  margin-bottom: 0.15rem;
}

.table-empty__hint {
  font-size: 0.82rem;
  color: #6e6b7b;
  margin-bottom: 0;
  max-width: 26rem;
}
</style>
